import { Injectable} from '@angular/core';

import { AbstractAsyncTaskReport } from '@core/components/async-tasks/async-task-reports/abstract-async-task.report';
import { ITask } from '@core/components/async-tasks/async-task-reports/async-task-constants';

@Injectable({
  providedIn: 'root'
})
export class LinktTerminateObjectsReport extends AbstractAsyncTaskReport {
  public generate(task: ITask): string {
    const detail = task.detail;
    let htmlDetail: string = '';
    if(task.status === 'success'){
      const devices: {ol: string, nd: string}[] = detail.terminated_devices || [];
      htmlDetail += `
        <div><strong>${devices.length} objet(s) résilié(s) avec succès : </strong></div>
        <ul>
            ${devices.map(device => `
              <li>
                OL : <strong>${device.ol}</strong> <br>
                ${device.nd ? `— ND : <strong>${device.nd}</strong>` : ''}
              </li>
            `).join('')}
        </ul>`;
    } else {
      const errors: {ol: string, nd: string}[] = detail.linkt_obj_error || [];
      htmlDetail += `
      <div><strong>Erreur lors de la résiliation des objets Linkt :</strong></div>
      <ul>
        ${errors.map(e => `
          <li>
            OL : <strong>${e.ol}</strong>
            ${e.nd ? `— ND : <strong>${e.nd}</strong>` : ''}
          </li>
        `).join('')}
      </ul>`;
    }
    return htmlDetail;
  }
}
